// ═══ ANYSA CUSTOM JS — Ported from anysa-html ═══

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── Nav scroll ──
  var nav = document.getElementById('anNav');
  if (nav) {
    var lastScrollY = window.scrollY;

    function updateNav(currentScrollY) {
      nav.classList.toggle('scrolled', currentScrollY > 60);
      if (currentScrollY > 60) {
        nav.classList.toggle('nav-hidden', currentScrollY > lastScrollY);
      } else {
        nav.classList.remove('nav-hidden');
      }
      // The announcement bar follows the nav (hidden on scroll down, shown on scroll up)
      document.documentElement.classList.toggle('an-nav-hidden', nav.classList.contains('nav-hidden'));
      lastScrollY = currentScrollY;
    }

    // Apply correct state immediately on load
    updateNav(window.scrollY);

    window.addEventListener('scroll', function () { updateNav(window.scrollY); }, { passive: true });
  }

  // ── Hero Slider ──
  var slides = document.querySelectorAll('.an-slide');
  var indicators = document.querySelectorAll('.an-indicator');
  var counter = document.getElementById('anCounter');
  var current = 0,
    timer;

  if (slides.length) {
    function goTo(n) {
      slides[current].classList.remove('active');
      if (indicators[current]) indicators[current].classList.remove('active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (indicators[current]) indicators[current].classList.add('active');
      if (counter) {
        counter.textContent =
          String(current + 1).padStart(2, '0') +
          ' / ' +
          String(slides.length).padStart(2, '0');
      }
    }
    function next() {
      goTo(current + 1);
    }
    function resetTimer() {
      clearInterval(timer);
      // Single slide or reduced motion: no autoplay
      if (reduceMotion || slides.length < 2) return;
      timer = setInterval(next, 6000);
    }

    var nextBtn = document.getElementById('anNextBtn');
    var prevBtn = document.getElementById('anPrevBtn');
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        next();
        resetTimer();
      });
    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        resetTimer();
      });
    indicators.forEach(function (el, i) {
      el.addEventListener('click', function () {
        goTo(i);
        resetTimer();
      });
    });
    resetTimer();

    // touch swipe
    var tx = 0;
    var heroEl = document.getElementById('anHero');
    if (heroEl) {
      heroEl.addEventListener(
        'touchstart',
        function (e) {
          tx = e.touches[0].clientX;
        },
        { passive: true },
      );
      heroEl.addEventListener(
        'touchend',
        function (e) {
          var d = tx - e.changedTouches[0].clientX;
          if (Math.abs(d) > 50) {
            d > 0 ? next() : goTo(current - 1);
            resetTimer();
          }
        },
        { passive: true },
      );
    }
  }

  // ── Mobile menu ──
  var hamburger = document.getElementById('anHamburger');
  var mobileMenu = document.getElementById('anMobileMenu');
  var mobileOverlay = document.getElementById('anMobileOverlay');

  if (hamburger && mobileMenu) {
    function openMenu() {
      hamburger.classList.add('open');
      hamburger.setAttribute('aria-expanded', 'true');
      mobileMenu.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      hamburger.classList.remove('open');
      hamburger.setAttribute('aria-expanded', 'false');
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    }
    hamburger.addEventListener('click', function () {
      hamburger.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (mobileOverlay) mobileOverlay.addEventListener('click', closeMenu);
    document
      .querySelectorAll('#anMobileMenu .an-mobile-menu-links a')
      .forEach(function (link) {
        link.addEventListener('click', closeMenu);
      });
    // Mobile accordion dropdowns
    document.querySelectorAll('.an-mob-dropdown').forEach(function (dd) {
      dd.querySelector('.an-mob-drop-btn').addEventListener(
        'click',
        function () {
          dd.classList.toggle('open');
        },
      );
    });
  }

  // ── Wishlist ──
  // Saved in this browser (localStorage) as a list of product handles. This file can be
  // included twice on some pages, so the handlers install once.
  if (!window.AnysaWishlist) {
    var WL_KEY = 'anysa:wishlist';
    var WL_MAX = 60;

    var wlRead = function () {
      try {
        var list = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };

    var wlSync = function () {
      var list = wlRead();
      document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
        var saved = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
        btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });
      document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
        badge.textContent = list.length;
        badge.hidden = list.length === 0;
      });
    };

    var wlWrite = function (list) {
      try {
        localStorage.setItem(WL_KEY, JSON.stringify(list.slice(0, WL_MAX)));
      } catch (e) {}
      wlSync();
      document.dispatchEvent(new CustomEvent('anysa:wishlist-change', { detail: { items: wlRead() } }));
    };

    window.AnysaWishlist = { read: wlRead, write: wlWrite, sync: wlSync };

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-wishlist-toggle');
      var list = wlRead();
      var at = list.indexOf(handle);
      if (at > -1) list.splice(at, 1);
      else list.unshift(handle);
      wlWrite(list);
    });

    // Another tab changed it
    window.addEventListener('storage', function (e) {
      if (e.key === WL_KEY) wlSync();
    });

    // Cards added later (infinite scroll, the wishlist page) pick up their state
    var wlPending = false;
    new MutationObserver(function () {
      if (wlPending) return;
      wlPending = true;
      requestAnimationFrame(function () {
        wlPending = false;
        wlSync();
      });
    }).observe(document.body, { childList: true, subtree: true });

    wlSync();
  }

  // ── Scroll reveal ──
  var revealObs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          revealObs.unobserve(e.target);
        }
      });
    },
    // Reveal slightly before an element enters, so fast thumb-scrolling never lands on a blank band
    { threshold: 0, rootMargin: '0px 0px 15% 0px' },
  );
  document.querySelectorAll('.an-reveal').forEach(function (el) {
    if (reduceMotion) {
      el.classList.add('in');
      return;
    }
    revealObs.observe(el);
  });
})();
